// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery-page {
  padding-top: 80px;
  min-height: 100vh;
}

.gallery-hero {
  position: relative;
  padding: 100px 0;
  background: linear-gradient(135deg, #0f4c81 0%, #1a73b8 50%, #2ea3d4 100%);
  overflow: hidden;
  color: white;
}

.gallery-hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.gallery-gradient-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.4;
  animation: float 20s infinite ease-in-out;
}

.gallery-gradient-orb.orb-1 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(46, 163, 212, 0.6) 0%, transparent 70%);
  top: -150px;
  right: -150px;
}

.gallery-gradient-orb.orb-2 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(15, 76, 129, 0.5) 0%, transparent 70%);
  bottom: -100px;
  left: -100px;
  animation-delay: -10s;
}

.gallery-hero-content {
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.gallery-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(20px);
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 32px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.gallery-title {
  font-size: 64px;
  font-weight: 700;
  margin-bottom: 24px;
  letter-spacing: -1.5px;
}

.gallery-description {
  font-size: 20px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.9);
  max-width: 600px;
  margin: 0 auto;
}

.gallery-filters {
  padding: 40px 0;
  background: white;
  border-bottom: 1px solid var(--border-color);
  position: sticky;
  top: 80px;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.filter-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.filter-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 28px;
  background: rgba(255, 255, 255, 0.12);
  border: 2px solid rgba(255, 255, 255, 0.18);
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(16px);
}

.filter-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.filter-btn.active {
  background: linear-gradient(135deg, #0f4c81, #1a73b8);
  color: white;
  border-color: transparent;
  box-shadow: 0 4px 16px rgba(15, 76, 129, 0.3);
}

.filter-count {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
  color: white;
}

.filter-btn.active .filter-count {
  background: rgba(255, 255, 255, 0.25);
  color: white;
}

.gallery-grid-section {
  padding: 80px 0;
  background: #f8f9fa;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 32px;
}

.gallery-item {
  opacity: 0;
  animation: fadeInUp 0.6s ease forwards;
  cursor: pointer;
}

.gallery-item-inner {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  aspect-ratio: 4/3;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.gallery-item-inner:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.15);
}

.gallery-item-inner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.gallery-item-inner:hover img {
  transform: scale(1.1);
}

.gallery-item-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.9) 100%);
  opacity: 0;
  transition: opacity 0.4s ease;
  display: flex;
  align-items: flex-end;
  padding: 32px;
  color: white;
}

.gallery-item-inner:hover .gallery-item-overlay {
  opacity: 1;
}

.gallery-item-content {
  width: 100%;
}

.gallery-item-content h3 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 8px;
  color: white;
}

.gallery-item-content p {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 16px;
  line-height: 1.5;
}

.gallery-item-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  transition: all 0.3s ease;
}

.gallery-item-inner:hover .gallery-item-icon {
  background: rgba(255, 215, 0, 0.9);
  color: #0f4c81;
  transform: rotate(90deg);
}

/* Lightbox */
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  animation: fadeIn 0.3s ease;
}

.lightbox-close {
  position: absolute;
  top: 32px;
  right: 32px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10002;
}

.lightbox-close:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: rotate(90deg);
}

.lightbox-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10002;
}

.lightbox-nav:hover {
  background: rgba(255, 255, 255, 0.2);
}

.lightbox-nav.prev {
  left: 32px;
}

.lightbox-nav.next {
  right: 32px;
}

.lightbox-content {
  max-width: 1200px;
  max-height: 90vh;
  animation: zoomIn 0.4s ease;
}

.lightbox-content img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5);
}

.lightbox-info {
  text-align: center;
  margin-top: 24px;
  color: white;
}

.lightbox-info h2 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 12px;
}

.lightbox-info p {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(50px, -50px) scale(1.1);
  }
  66% {
    transform: translate(-50px, 50px) scale(0.9);
  }
}

/* Tablet */
@media (max-width: 968px) {
  .gallery-title {
    font-size: 48px;
  }

  .gallery-description {
    font-size: 18px;
  }

  .gallery-grid {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 24px;
  }

  .filter-buttons {
    gap: 12px;
  }

  .filter-btn {
    padding: 12px 20px;
    font-size: 14px;
  }
}

/* Mobile */
@media (max-width: 640px) {
  .gallery-hero {
    padding: 60px 0;
  }

  .gallery-title {
    font-size: 36px;
  }

  .gallery-description {
    font-size: 16px;
  }

  .gallery-filters {
    top: 72px;
    padding: 24px 0;
  }

  .filter-buttons {
    gap: 8px;
  }

  .filter-btn {
    padding: 10px 16px;
    font-size: 13px;
  }

  .filter-count {
    min-width: 24px;
    height: 24px;
    font-size: 12px;
  }

  .gallery-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .gallery-grid-section {
    padding: 40px 0;
  }

  .lightbox {
    padding: 20px;
  }

  .lightbox-close,
  .lightbox-nav {
    width: 44px;
    height: 44px;
  }

  .lightbox-close {
    top: 20px;
    right: 20px;
  }

  .lightbox-nav.prev {
    left: 20px;
  }

  .lightbox-nav.next {
    right: 20px;
  }

  .lightbox-content img {
    max-height: 50vh;
  }

  .lightbox-info h2 {
    font-size: 22px;
  }

  .lightbox-info p {
    font-size: 14px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/GalleryPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0EAA0E;EAC1E,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gFAAgF;EAChF,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+EAA+E;EAC/E,cAAc;EACd,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4CAA4C;EAC5C,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,UAAU;EACV,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+EAA+E;EAC/E,UAAU;EACV,6BAA6B;EAC7B,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wBAAwB;AAC1B;;AAEA,aAAa;AACb;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA,WAAW;AACX;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,WAAW;AACX;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".gallery-page {\n  padding-top: 80px;\n  min-height: 100vh;\n}\n\n.gallery-hero {\n  position: relative;\n  padding: 100px 0;\n  background: linear-gradient(135deg, #0f4c81 0%, #1a73b8 50%, #2ea3d4 100%);\n  overflow: hidden;\n  color: white;\n}\n\n.gallery-hero-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n}\n\n.gallery-gradient-orb {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(80px);\n  opacity: 0.4;\n  animation: float 20s infinite ease-in-out;\n}\n\n.gallery-gradient-orb.orb-1 {\n  width: 500px;\n  height: 500px;\n  background: radial-gradient(circle, rgba(46, 163, 212, 0.6) 0%, transparent 70%);\n  top: -150px;\n  right: -150px;\n}\n\n.gallery-gradient-orb.orb-2 {\n  width: 400px;\n  height: 400px;\n  background: radial-gradient(circle, rgba(15, 76, 129, 0.5) 0%, transparent 70%);\n  bottom: -100px;\n  left: -100px;\n  animation-delay: -10s;\n}\n\n.gallery-hero-content {\n  position: relative;\n  z-index: 1;\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.gallery-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 24px;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(20px);\n  border-radius: 50px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 32px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n}\n\n.gallery-title {\n  font-size: 64px;\n  font-weight: 700;\n  margin-bottom: 24px;\n  letter-spacing: -1.5px;\n}\n\n.gallery-description {\n  font-size: 20px;\n  line-height: 1.7;\n  color: rgba(255, 255, 255, 0.9);\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.gallery-filters {\n  padding: 40px 0;\n  background: white;\n  border-bottom: 1px solid var(--border-color);\n  position: sticky;\n  top: 80px;\n  z-index: 100;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.filter-buttons {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.filter-btn {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 28px;\n  background: rgba(255, 255, 255, 0.12);\n  border: 2px solid rgba(255, 255, 255, 0.18);\n  border-radius: 50px;\n  font-size: 15px;\n  font-weight: 600;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(16px);\n}\n\n.filter-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n}\n\n.filter-btn.active {\n  background: linear-gradient(135deg, #0f4c81, #1a73b8);\n  color: white;\n  border-color: transparent;\n  box-shadow: 0 4px 16px rgba(15, 76, 129, 0.3);\n}\n\n.filter-count {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 28px;\n  height: 28px;\n  padding: 0 8px;\n  background: rgba(255, 255, 255, 0.18);\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 700;\n  color: white;\n}\n\n.filter-btn.active .filter-count {\n  background: rgba(255, 255, 255, 0.25);\n  color: white;\n}\n\n.gallery-grid-section {\n  padding: 80px 0;\n  background: #f8f9fa;\n}\n\n.gallery-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 32px;\n}\n\n.gallery-item {\n  opacity: 0;\n  animation: fadeInUp 0.6s ease forwards;\n  cursor: pointer;\n}\n\n.gallery-item-inner {\n  position: relative;\n  border-radius: 20px;\n  overflow: hidden;\n  aspect-ratio: 4/3;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.gallery-item-inner:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.15);\n}\n\n.gallery-item-inner img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.6s ease;\n}\n\n.gallery-item-inner:hover img {\n  transform: scale(1.1);\n}\n\n.gallery-item-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.9) 100%);\n  opacity: 0;\n  transition: opacity 0.4s ease;\n  display: flex;\n  align-items: flex-end;\n  padding: 32px;\n  color: white;\n}\n\n.gallery-item-inner:hover .gallery-item-overlay {\n  opacity: 1;\n}\n\n.gallery-item-content {\n  width: 100%;\n}\n\n.gallery-item-content h3 {\n  font-size: 24px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  color: white;\n}\n\n.gallery-item-content p {\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.9);\n  margin-bottom: 16px;\n  line-height: 1.5;\n}\n\n.gallery-item-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  transition: all 0.3s ease;\n}\n\n.gallery-item-inner:hover .gallery-item-icon {\n  background: rgba(255, 215, 0, 0.9);\n  color: #0f4c81;\n  transform: rotate(90deg);\n}\n\n/* Lightbox */\n.lightbox {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.95);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  animation: fadeIn 0.3s ease;\n}\n\n.lightbox-close {\n  position: absolute;\n  top: 32px;\n  right: 32px;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 10002;\n}\n\n.lightbox-close:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: rotate(90deg);\n}\n\n.lightbox-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 10002;\n}\n\n.lightbox-nav:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.lightbox-nav.prev {\n  left: 32px;\n}\n\n.lightbox-nav.next {\n  right: 32px;\n}\n\n.lightbox-content {\n  max-width: 1200px;\n  max-height: 90vh;\n  animation: zoomIn 0.4s ease;\n}\n\n.lightbox-content img {\n  max-width: 100%;\n  max-height: 70vh;\n  object-fit: contain;\n  border-radius: 12px;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5);\n}\n\n.lightbox-info {\n  text-align: center;\n  margin-top: 24px;\n  color: white;\n}\n\n.lightbox-info h2 {\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 12px;\n}\n\n.lightbox-info p {\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.8);\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes zoomIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translate(0, 0) scale(1);\n  }\n  33% {\n    transform: translate(50px, -50px) scale(1.1);\n  }\n  66% {\n    transform: translate(-50px, 50px) scale(0.9);\n  }\n}\n\n/* Tablet */\n@media (max-width: 968px) {\n  .gallery-title {\n    font-size: 48px;\n  }\n\n  .gallery-description {\n    font-size: 18px;\n  }\n\n  .gallery-grid {\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 24px;\n  }\n\n  .filter-buttons {\n    gap: 12px;\n  }\n\n  .filter-btn {\n    padding: 12px 20px;\n    font-size: 14px;\n  }\n}\n\n/* Mobile */\n@media (max-width: 640px) {\n  .gallery-hero {\n    padding: 60px 0;\n  }\n\n  .gallery-title {\n    font-size: 36px;\n  }\n\n  .gallery-description {\n    font-size: 16px;\n  }\n\n  .gallery-filters {\n    top: 72px;\n    padding: 24px 0;\n  }\n\n  .filter-buttons {\n    gap: 8px;\n  }\n\n  .filter-btn {\n    padding: 10px 16px;\n    font-size: 13px;\n  }\n\n  .filter-count {\n    min-width: 24px;\n    height: 24px;\n    font-size: 12px;\n  }\n\n  .gallery-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .gallery-grid-section {\n    padding: 40px 0;\n  }\n\n  .lightbox {\n    padding: 20px;\n  }\n\n  .lightbox-close,\n  .lightbox-nav {\n    width: 44px;\n    height: 44px;\n  }\n\n  .lightbox-close {\n    top: 20px;\n    right: 20px;\n  }\n\n  .lightbox-nav.prev {\n    left: 20px;\n  }\n\n  .lightbox-nav.next {\n    right: 20px;\n  }\n\n  .lightbox-content img {\n    max-height: 50vh;\n  }\n\n  .lightbox-info h2 {\n    font-size: 22px;\n  }\n\n  .lightbox-info p {\n    font-size: 14px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
